export const ariaLabel = {
  logout: "Se déconnecter",
  download: "Télécharger",
  deleteFile: "Supprimer le fichier",
  closeModal: "Fermer la fenêtre modale",
  ibanInfos: "Informations sur l'IBAN",
  showPassword: "Afficher le mot de passe",
  hidePassword: "Masquer le mot de passe",
  confirmationPassword: "Ré-écrire le mot de passe pour confirmer",
  close: "Fermer",
  downloadPDF: "Télécharger en PDF -",
  sellPromiseDate: "Saisir la date de promesse de vente (ex : 01/01/2025)",
  createdAt: "Date de création",
  myTickets: "Mes demandes",
  clientSettings: "Paramètres compte client",
  resolutionTable: "Tableau des résolutions",
  datePickerDialog: "Sélecteur de date",
  datePickerSwitchViewButton: "Sélectionner une année",
  datePickerLeftArrowIcon: "Mois précédent",
  datePickerRightArrowIcon: "Mois suivant",
  clearSelection: "Vider la sélection",
  openFamilyStatusList: "Ouvrir la liste des situations familiales",
  closeFamilyStatusList: "Fermer la liste des situations familiales",
  closeTrusteeDocumentsList: "Fermer la liste des documents liés au contrat",
  noResults: "Aucun résultat",
  openCountryList: "Ouvrir la liste des pays",
  closeCountryList: "Fermer la liste des pays",
  leftNavBar: "Barre de navigation latérale",
  header: "En-tête de la page",
  footer: "Pied de page",
  main: "Contenu principal de la page",
  headNavBar: "Barre de navigation supérieure",
  accountSearchBar: "Barre de recherche de compte",
  accountNavBar: "Barre de navigation du compte",
  councilNavBar: "Barre de navigation du conseil syndical",
  councilServicesNavBar: "Barre de navigation des interventions du conseil syndical",
  councilAccountingNavBar: "Barre de navigation de la comptabilité du conseil syndical",
  accountingNavBar: "Barre de navigation de la comptabilité",
  searchAccountTextField: "Rechercher un compte",
  ticketInputDescriptionLabel: "Descriptif",
  ibanInputLabel: "N° IBAN",
  firstNameInputLabel: "Prénom",
  lastNameInputLabel: "Nom",
  documentListSelectCheckbox: "Selectionner le document",
  listSelectAllCheckbox: "Sélectionner tous les éléments",
  listSelectCheckbox: "Sélectionner l'élément",
  documentListFilters: "Filtres de la liste des documents",
  documentListSearchInput: "Chercher un document par son nom",
  listHeader: "En-tête de la liste",
  columnsHeadersRow: "En-tête des colonnes de la liste",
  dashboardTitle: "Mon tableau de bord",
  ticketsTitle: "Mes demandes",
  missionIncidentsTitle: "Mes interventions",
  notificationsTitle: "Mes notifications",
  accountingTitle: "Ma comptabilité",
  offersAndServicesTitle: "Offres et services",
  estateTitle: "Mes biens",
  documentsTitle: "Mes documents",
  paymentsTitle: "Mes paiements",
  generalAssemblyTitle: "Mon assemblée générale",
  councilTitle: "Mon conseil syndical",
  tenantsBalanceTitle: "Mes locataires",
  passwordContainsUpperCase: "Votre mot de passe contient une majuscule",
  passwordContainsLowerCase: "Votre mot de passe contient une minuscule",
  passwordContainsDigit: "Votre mot de passe contient un chiffre",
  passwordIsLongEnough: "Votre mot de passe contient au moins 8 caractères",
  passwordDoesNotContainUpperCase: "Votre mot de passe ne contient pas de majuscule",
  passwordDoesNotContainLowerCase: "Votre mot de passe ne contient pas de minuscule",
  passwordDoesNotContainDigit: "Votre mot de passe ne contient pas de chiffre",
  passwordIsNotLongEnough: "Votre mot de passe ne contient pas au moins 8 caractères",
  selectAllUnits: "Sélectionner tous les lots",
  unselectAllUnits: "Désélectionner tous les lots",
  select: "Sélectionner",
  deselect: "Désélectionner",
  openMenuButtonLabel: "Ouvrir le menu",
  closeMenuButtonLabel: "Fermer le menu",
  menuLabel: "Menu principal",
  dropZoneLabel: "Pièces jointes",
  browseFilesButtonLabel:
    "Parcourir pour saisir une pièce jointe - ajoutez jusqu'à 5 pièces jointes",
  accessAccountLabel: "Accéder au compte",
  showAccountsLabel: "Afficher les comptes",
  paginationLabel: "Pagination",
  previousPageLabel: "Page précédente",
  nextPageLabel: "Page suivante",
  pageLabel: "Page",
  paymentGoBackButtonLabel: "Revenir aux modes de paiement",
  goToMarketPlaceLabel: "Accéder à la marketplace",
  helpDeskShowMoreButtonLabel: "En savoir plus sur l'assistance",
  offersAndServicesShowMoreButtonLabel: "En savoir plus sur les offres et services",
  sortDirectionAscLabel: "par ordre croissant",
  sortDirectionDescLabel: "par ordre décroissant",
  documentsGoBackButtonLabel: "Retour à mes documents",
  mobilePhoneInputLabel: "Téléphone mobile",
  landlinePhoneInputLabel: "Téléphone fixe",
  birthDateInputLabel: "Date de naissance",
  familyStatusInputLabel: "Situation familiale",
  startDateInputLabel: "Date de début",
  endDateInputLabel: "Date de fin",
  customerAreaLinkLabel: "Lien vers l'espace client",
  numerikaLinkLabel: "Lien vers Numerika",
  rgaaLinkLabel: "Lien vers la conformité RGAA",
  rightsProtectorLinkLabel: "Lien vers le protecteur des droits",
  delegateDirectoryRightLabel: "Lien vers l'annuaire des délégués",
  actionPlanTableLabel: "Tableau des plans d'action",
  branchScheduleRow: "Horaire de l'agence pour le",
  circularProgressLabel: "Chargement en cours",
  showCustomerAccountsLabel: "Afficher les comptes du client",
  hideCustomerAccountsLabel: "Masquer les comptes du client",
  landlordAccountingLinkLabel: "Lien vers ma comptabilité de mon compte de bailleur",
  landlordTenantsBalanceLinkLabel: "Lien vers le solde de mes locataires de mon compte de bailleur",
  ticketsLinkLabel: "Lien vers mes demandes",
  linkToDocumentsLabel: "Lien vers les documents",
  eRecoSubscriptionButtonLabel: "Souscription au service E-reco",
  coOwnerQuality: "Qualité du copropriétaire",
  yearSelect: "Sélectionner une année",
  monthSelect: "Sélectionner un mois",
  accountingPeriodSelect: "Sélectionner une période comptable",
  totalAmmountsRowLabel: "Montants totaux",
  budgetSelect: "Sélectionner un budget",
  allocationKeySelect: "Sélectionner une clé de répartition",
  expenseTypeSelect: "Sélectionner un type de charge",
  dateAndTimeOfGA: "Date et heure de l'assemblée générale",
  placeOfGA: "Lieu de l'assemblée générale",
  trusteeDocumentsList: "Liste des documents liés au contrat",
  ticketCategorySelect: "Sélectionner une catégorie de demande",
  ticketStatusSelect: "Sélectionner un statut de demande",
  ticketSourceSelect: "Sélectionner une source de demande",
  ticketResponseStatusSelect: "Sélectionner un statut de réponse de demande",
  referenceInputLabel: "Référence",
  landlordPropertyAssetsYearSelect: "Sélectionner une année d'actif de bien",
  landlordPropertyAssetsBuildingSelect: "Sélectionner un immeuble d'actif de bien",
  ticketsCategoryFilter: "Filtrer par objet",
  ticketsStatusFilter: "Filtrer par statut",
  ticketsReferenceFilter: "Filtrer par référence",
  ticketsSourceFilter: "Filtrer par source",
  ticketsDateFilter: "Filtrer par date",
  missionIncidentsStatusFilter: "Filtrer par statut",
  missionIncidentsLabelFilter: "Filtrer par libellé",
  missionIncidentsNumberFilter: "Filtrer par référence",
  missionIncidentsStartedAtGteFilter: "Filtrer par date de début (à partir de)",
  missionIncidentsStartedAtLteFilter: "Filtrer par date de début (jusqu'au)",
  orderSaleAgreementEmailInput: "Adresse email pour l'envoi du DPV",
  orderSaleAgreementBuildingInput: "Nom de l’immeuble",
  confirmAllPropertiesManagedToggle:
    "Confirmation que tous les biens figurant sur la taxe foncière sont gérés par",
  amountToWithdrawInput: "Montant à prélever",
  chooseBankSelect: "Choisir une banque",
  subCategoriesSelect: "Sélectionner une ou plusieurs catégories de documents",
  estateDetailDialog: "Informations du lot",
  oneLastLookDialog: "Un dernier coup d'œil",
  landlordPropertyTaxConfirmCheckBox:
    "Sélectionner que je certifie que ces informations sont exactes et correspondent à celles fournies par l'administration fiscale",
  tenantInsuranceConfirmCheckBox:
    "Sélectionner que je certifie que ces informations sont exactes et correspondent à celles fournies par mon assureur",
  tenantHeatingCertificateConfirmCheckBox:
    "Sélectionner que je certifie que ces informations sont exactes et correspondent à celles fournies par la société d'entretien",
} as const;
